// extracted by mini-css-extract-plugin
export var logoWrapper = "h0_CC";